import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import globals from '@/globals'

// Layouts
import Layout1 from '@/layout/Layout1'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  base: '/',
  mode: 'hash',
  routes: [{
    path: '/',
    component: Layout1,
    children: [
      {
        path: '',
        component: () => import('@/components/Home')
      }, {
        path: 'page-2',
        component: () => import('@/components/Page2')
      }, {
        path: 'users',
        component: () => import('@/components/users/Users')
      },
      {
        path: 'users/:id',
        name: 'user-edit',
        component: () => import('@/components/users/Edit')
      },
      {
        path: 'canines',
        component: () => import('@/components/canine/Canines')
      },
      {
        path: 'canines/:id',
        name: 'canine-edit',
        component: () => import('@/components/canine/Canine-edit')
      },
      {
        path: 'canines/new',
        name: 'canine-new',
        component: () => import('@/components/canine/Canine-new')
      },
      {
        path: 'expos',
        name: 'expos',
        component: () => import('@/components/expos/Expos')
      },
      {
        path: 'inscriptions',
        name: 'inscriptions',
        component: () => import('@/components/inscriptions/Inscriptions')
      },
      {
        path: 'inscriptions/new',
        name: 'inscriptions-new',
        component: () => import('@/components/inscriptions/inscription-new/Inscriptions-new')
      },
      {
        path: 'expos/new',
        name: 'expo-new',
        component: () => import('@/components/expos/Expo-new')
      },
      {
        path: 'expos/edit/:id',
        name: 'expo-form-edit',
        props: true,
        component: () => import('@/components/expos/Expo-form')
      },
      {
        path: 'config',
        component: () => import('@/components/config/Config.vue')
      },
      {
        path: 'config/prices',
        component: () => import('@/components/config/Config-prices.vue')
      },
      {
        path: 'config/races',
        component: () => import('@/components/config/Races-config.vue')
      }
    ]
  }, {
    path: '/login',
    component: () => import('@/components/login/Login')
  }

  ]

})

router.afterEach(() => {
  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  // Set loading state
  document.body.classList.add('app-loading')

  const publicPages = ['/login', '/register'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10)
})

export default router
